import Link from 'next/link'

import { useProductPaymentsQuery } from '@/screens/Product/hooks/use-product-payments-query'
import { useProduct } from '@/screens/Product/hooks/useProduct'

import { DolyameIcon } from '@/widgets/dolyame-widget/ui/dolyame-modal/assets/dolyame-icon'

import { Button } from '@/shared/ui'

import { DolyameBenes } from '../dolyame-benes/dolyame-benes'
import { DolyamePayTable } from '../dolyame-pay-table/dolyame-pay-table'

import cl from './style.module.scss'

export interface DolyameModalProps {
	onClick: () => void
}

export const DolyameModal = (props: DolyameModalProps) => {
	const { onClick } = props
	const { product } = useProduct()

	const { data } = useProductPaymentsQuery(Number(product.ID))
	const items = data?.data?.DOLYAME || []
	return (
		<div className={cl.root}>
			<h2 className={cl.title}>Разделите стоимость покупки</h2>
			<p className={cl.subtitle}>Заплатите сейчас только часть, а оставшееся будем списывать каждые две недели</p>
			<DolyameBenes />
			<DolyamePayTable items={items} />
			<Button className={cl.button} onClick={onClick}>
				Оплатить
				<DolyameIcon />
			</Button>
			<p className={cl.note}>
				Подробнее о сервисе можно узнать на{' '}
				<Link prefetch={false} href={'https://dolyame.ru/'} target={'_blank'}>
					dolyame.ru
				</Link>
			</p>
		</div>
	)
}
